(()=>{const page=document.querySelector('.rb-page');if(!page)return;const bar=document.querySelector('.rb-sticky');const hero=document.querySelector('.rb-hero');const reserve=document.querySelector('#reserve');if(bar&&hero&&reserve&&'IntersectionObserver'in window){let heroOn=true,reserveOn=false;const update=()=>bar.classList.toggle('visible',!heroOn&&!reserveOn);new IntersectionObserver(([e])=>{heroOn=e.isIntersecting;update()},{threshold:0}).observe(hero);new IntersectionObserver(([e])=>{reserveOn=e.isIntersecting;update()},{threshold:0}).observe(reserve)}})();

(()=>{const video=document.querySelector('.rb-hero-video');if(!video)return;video.muted=true;video.loop=true;video.play().catch(()=>{})})();

(()=>{const v=document.querySelector(".rb-lounge-video");if(!v)return;v.muted=true;v.loop=true;if("IntersectionObserver"in window){new IntersectionObserver(([entry])=>{if(entry.isIntersecting)v.play().catch(()=>{});else v.pause()},{rootMargin:"150px"}).observe(v)}else v.play().catch(()=>{})})();

/* Land reservation links on the payment controls, including on short mobile screens. */
(()=>{
  const card=document.querySelector('.rb-reserve-card');
  if(!card)return;
  let stopWatching=()=>{};
  const payment=()=>card.querySelector('.shopify-payment-button')||card.querySelector('.rb-express-form')||card.querySelector('button');
  const position=(behavior)=>{
    const target=payment();
    if(!target)return;
    const viewport=window.visualViewport;
    const height=viewport?viewport.height:window.innerHeight;
    const offset=viewport?viewport.offsetTop:0;
    const bottom=target.getBoundingClientRect().bottom+window.scrollY;
    const cardTop=card.getBoundingClientRect().top+window.scrollY;
    const paymentTop=bottom-height+48-offset;
    const top=window.matchMedia('(max-width:749px)').matches?paymentTop:cardTop-40-offset;
    window.scrollTo({top:Math.max(0,top),behavior});
  };
  const reveal=()=>{
    stopWatching();
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    position(reduced?'instant':'smooth');
    card.setAttribute('tabindex','-1');
    card.focus({preventScroll:true});
    // Wallet buttons can finish rendering after the anchor is followed.
    let observer;
    const cancel=()=>{
      if(observer)observer.disconnect();
      clearTimeout(timer);
      ['wheel','touchstart','pointerdown','keydown'].forEach(type=>window.removeEventListener(type,cancel));
    };
    const timer=setTimeout(cancel,3000);
    stopWatching=cancel;
    ['wheel','touchstart','pointerdown','keydown'].forEach(type=>window.addEventListener(type,cancel,{passive:true,once:true}));
    if('ResizeObserver'in window){
      observer=new ResizeObserver(()=>position(reduced?'instant':'smooth'));
      observer.observe(card);
      const target=payment();
      if(target)observer.observe(target);
    }
  };
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin||url.pathname!==location.pathname||url.hash!=='#reserve')return;
    event.preventDefault();
    if(location.hash!=='#reserve')history.pushState(null,'','#reserve');
    reveal();
  });
  window.addEventListener('hashchange',()=>{if(location.hash==='#reserve')reveal()});
  if(location.hash==='#reserve'){
    if(document.readyState==='complete')reveal();
    else window.addEventListener('load',reveal,{once:true});
  }
})();
/* One section setting drives both clocks and launch-date labels. */
(()=>{
  const initialise=()=>{
    const hero=document.querySelector('[data-rb-launch-at]');
    if(!hero)return;
    if(window.rbLaunchCountdownTimer)clearInterval(window.rbLaunchCountdownTimer);
    const target=Date.parse(hero.dataset.rbLaunchAt);
    const clocks=document.querySelectorAll('[data-rb-countdown]');
    if(!Number.isFinite(target)){clocks.forEach(el=>el.hidden=true);return;}
    const date=new Date(target);
    document.querySelectorAll('[data-rb-launch-date]').forEach(el=>{
      const options={timeZone:'America/New_York',month:'long',day:'numeric'};
      if(el.hasAttribute('data-rb-launch-year'))options.year='numeric';
      el.textContent=new Intl.DateTimeFormat('en-US',options).format(date);
    });
    const update=()=>{
      const remaining=target-Date.now();
      clocks.forEach(el=>el.hidden=remaining<=0);
      if(remaining<=0){clearInterval(window.rbLaunchCountdownTimer);return;}
      const mins=Math.floor(remaining/60000);
      const quantity=(n,label)=>`${n} ${label}${n===1?'':'s'}`;
      const text=[quantity(Math.floor(mins/1440),'day'),quantity(Math.floor(mins/60)%24,'hour'),quantity(mins%60,'minute')].join(' · ');
      clocks.forEach(el=>{const output=el.querySelector('[data-rb-countdown-time]');if(output)output.textContent=text;});
    };
    update();
    if(target>Date.now())window.rbLaunchCountdownTimer=setInterval(update,1000);
  };
  initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
